import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import React from 'react';

interface InfoInterface {
  state: boolean
  setState: (value: React.SetStateAction<boolean>) => void
}

const Info = (props: InfoInterface) => {

  const toggleDrawer =
    (open: boolean) =>
      (event: React.KeyboardEvent | React.MouseEvent) => {
        if (
          event.type === 'keydown' &&
          ((event as React.KeyboardEvent).key === 'Tab' ||
            (event as React.KeyboardEvent).key === 'Shift')
        ) {
          return;
        }

        props.setState(open);
      };

  return (
    <div>
      <Drawer
        anchor={'left'}
        open={props.state}
        onClose={toggleDrawer(false)}
      >
        <Box
          sx={{
            width: 250,
            padding: "10px"
          }}
        >
          <h2>
            Welcome!
          </h2>
          <p>You can use this website to quickly search for recipes from a recipe collection assembled by Maya Weissman, Alexandra D'Ordine, and Karl Parks.</p>
          <h3>
            Information
          </h3>
          <p>
            At the moment, Keyword searches are AND queries meaning that each recipe in the filtered recipe list will have keyword tag "a" AND keyword tag "b". As you add more keywords, the available options to select from will slowly reduce to assist you with narrowing your query. :)
          </p>
          <p>
            The Advanced Search options are primarily OR queries meaning that each recipe in the filtered recipe list will have column tag "a" OR column "b". All OR queries are initially indicated with a purple outline. In the Advanced case, we intentionally do not limit the available options for selection.
          </p>
          <p>
            All filtered results pass from top to bottom. Aka, the filtered recipe list from a Category search feeds into the Cuisine search next, and continues down the line. The more restrictive your search is at the top, the less useful your search potentially is below.
          </p>
          <p>
            Click the settings icon and click "sync" to pull from an externally available .csv file (of a very specific structure). In our case, we use a google spreadsheet that is "published" on the web as a .csv; this is the easiest way to provide a very easily updatable "backend" for our app to use.
          </p>
          <p>
            Q: What's with the floating bread?<br />A: It is a dancing baugette and it is awesome. That is all.
          </p>
          <p>ENJOY!</p>
        </Box>
      </Drawer>
    </div>
  )
}

export default Info